// uiarc: dialog/drawer `SwapText` (https://uiarc.dev/r/dialog.json). Açıkken başlık ya da açıklama değişirse yeni
// metin bulanıklıktan yükselir, eskisi yukarı çıkar. `prefers-reduced-motion` altında yalnız solma.
import { AnimatePresence, motion, useReducedMotion } from 'motion/react'
import type { ReactNode } from 'react'
import { motionTokens } from '@/lib/motion'

const { blur, duration, ease } = motionTokens

function SwapText({ text }: { text: string }) {
  const reduced = useReducedMotion()
  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.span
        key={text}
        className="block [line-height:inherit]"
        initial={reduced ? false : { opacity: 0, y: '0.3em', filter: `blur(${blur.soft}px)` }}
        animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
        exit={
          reduced
            ? { opacity: 0, transition: { duration: 0 } }
            : {
                opacity: 0,
                y: '-0.3em',
                filter: `blur(${blur.subtle}px)`,
                transition: { duration: duration.fast, ease: ease.standard },
              }
        }
        transition={{ duration: duration.standard, ease: ease.enter }}
      >
        {text}
      </motion.span>
    </AnimatePresence>
  )
}

/** Metin (string/number) ise değişimi animasyonlar; öğe içeren içerik olduğu gibi kalır. */
function SwapContent({ children }: { children?: ReactNode }) {
  if (typeof children === 'string' || typeof children === 'number')
    return <SwapText text={String(children)} />
  return <>{children}</>
}

export { SwapContent, SwapText }
